<template>
  <Item tag="router-link" :to="action" :type="value.typename.toLowerCase()" :title="title">
    <template #datetime>
      <div class="row middle">
        <FontAwesomeIcon :icon="['fal', 'calendar-exclamation']" style="margin-right: 3px" />
        <span>{{ expiresAt | Moment('DD. MMM [kl.] HH.mm') }}</span>
      </div>
    </template>
    <template #details>
      <div v-if="$route.name === 'dashboard'">
        <FontAwesomeIcon :icon="['fal', 'drafting-compass']" style="margin-right: 3px" />
        {{ value.project.name }}
      </div>
      <div>
        <FontAwesomeIcon :icon="['fal', 'house']" style="margin-right: 3px" />
        {{ value.reference.name }}
      </div>
    </template>
  </Item>
</template>

<script>
import Item from '@/components/ListItem'
import { Moment } from '@/filters'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    title() {
      switch (this.value.status) {
        case 'draft':
          return this.$t('prepareShop')
        case 'signed':
          return `${this.$t('accept')}/${this.$t('decline')}`
      }
    },
    action() {
      switch (this.value.status) {
        case 'draft':
          return { name: 'shop', params: { id: this.value.reference.shop.id } }
        case 'signed':
          return { name: 'contract', params: { id: this.value.id } }
      }
    },
    expiresAt() {
      return this.value.expiresAt || new Date()
    },
  },
  filters: {
    Moment,
  },
  components: {
    Item,
  },
}
</script>

<style lang="scss">
.list-item--shopcontract {
  a {
    text-decoration: none;
  }
}
</style>
